import React from 'react';
import {
  Dialog, DialogContent, DialogActions, Button, Box, Typography, CircularProgress,
} from '@mui/material';
import { color, radius } from '../../theme/tokens';

/**
 * Confirmation dialog for destructive or irreversible actions.
 * Replaces window.confirm so confirmations match the design system.
 */
const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'danger',
  icon,
  loading = false,
}) => {
  const accent = tone === 'danger' ? color.danger : tone === 'gold' ? color.goldTone : color.neutral;

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ pt: 3, pb: 1 }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box
            sx={{
              width: 40, height: 40, flexShrink: 0,
              borderRadius: `${radius.lg}px`,
              backgroundColor: accent.bg,
              border: `1px solid ${accent.border}`,
              color: accent.text,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              '& svg': { fontSize: 20 },
            }}
          >
            {icon || '!'}
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: color.ink[900] }}>{title}</Typography>
            {description && (
              <Typography sx={{ mt: 0.75, fontSize: '0.875rem', color: color.ink[500], lineHeight: 1.5 }}>
                {description}
              </Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1 }}>
        <Button onClick={onClose} disabled={loading} variant="outlined" color="inherit">
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          color={tone === 'danger' ? 'error' : 'primary'}
        >
          {loading ? <CircularProgress size={18} color="inherit" /> : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
